import React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useShiftsForDate } from '~/hooks/api/useShiftsForDate';
import moment from 'moment';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import { Link } from '@tanstack/react-router';

type ShiftSelectProps = {
  year: number;
  month: number;
  day: number;
  selectedShift: number;
  routeId: number;
};

const ShiftSelect = (props: ShiftSelectProps) => {
  const { data: shiftCollection, isLoading } = useShiftsForDate(
    props.year,
    props.month,
    props.day,
    ['turns.route']
  );
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const shiftsWithTurns = shiftCollection?.getShiftsWithTurnsOrderdByDate();
  const selectedShift = shiftCollection?.getShiftById(props.selectedShift);

  return !isLoading ? (
    <>
      <Button
        id="shift-selection-buttion"
        aria-controls={open ? 'shift-selection-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        color="inherit"
        endIcon={<ArrowDropDown />}
      >
        {moment(selectedShift?.startDate).format('LT')}
        {' - '}
        {moment(selectedShift?.endDate).format('LT')}
      </Button>
      <Menu
        id="shift-selection-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': 'shift-selection-buttion',
          },
        }}
      >
        {shiftsWithTurns?.map((shift) => {
          const turnToNavigateTo = shift.getTurnWithRoute(props.routeId);
          return (
            <MenuItem
              key={shift.id}
              onClick={handleClose}
              component={Link}
              to={`/weekplan/assignment/${shift.id}/${turnToNavigateTo.id}`}
            >
              {moment(shift.startDate).format('LT')}
              {' - '}
              {moment(shift.endDate).format('LT')}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  ) : null;
};

export default ShiftSelect;
